
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quoto",
      function () {
        return require("private-next-pages/quoto/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quoto"])
      });
    }
  